import React from 'react';

import { Text, Card, WrapperFlex } from '@unimed-fesp/components';

import ModalidadeEnum from '../../../enums/ModalidadeEnum';
import StatusListaAPIEnum from '../../../enums/StatusListaAPIEnum';

import theme from '../../../styles/theme';

function DadosLista({ lista }) {
  return (
    <Card margin={0}>
      <Text
        color={theme.movGrey}
        text="Dados da Lista"
        tipo="headlineOne"
        extraHuge
        marginBottom={50}
      />
      <WrapperFlex row>
        <WrapperFlex column minWidth={250}>
          <WrapperFlex column>
            <Text
              font="bold 16px/14px Calibri"
              color={theme.movGrey}
              text="Status"
              paddingBottom={10}
            />
            <Text
              color={theme.movGrey90}
              text={
                StatusListaAPIEnum.returnNameFormatted[lista?.idStatusLista] ||
                '-'
              }
              paddingBottom={20}
            />
          </WrapperFlex>
          <WrapperFlex column>
            <Text
              font="bold 16px/14px Calibri"
              color={theme.movGrey}
              text="Lista"
              paddingBottom={10}
            />
            <Text
              color={theme.movGrey90}
              text={lista?.nmLista || '-'}
              paddingBottom={20}
            />
          </WrapperFlex>
          <WrapperFlex column>
            <Text
              font="bold 16px/14px Calibri"
              color={theme.movGrey}
              text="Modalidade Destino"
              paddingBottom={10}
            />
            <Text
              color={theme.movGrey90}
              text={
                lista?.nrCodigoModalidade
                  ? ModalidadeEnum.returnNameFormattedForId[
                      lista?.nrCodigoModalidade
                    ]
                  : '-'
              }
              paddingBottom={20}
            />
          </WrapperFlex>
        </WrapperFlex>

        <WrapperFlex column>
          <WrapperFlex column>
            <Text
              font="bold 16px/14px Calibri"
              color={theme.movGrey}
              text="Contratante"
              paddingBottom={10}
            />
            <Text
              color={theme.movGrey90}
              text={
                lista?.cdContratante
                  ? `${lista?.cdContratante} - ${lista?.nmEmpresa}`
                  : '-'
              }
              paddingBottom={20}
            />
          </WrapperFlex>
          <WrapperFlex column>
            <Text
              font="bold 16px/14px Calibri"
              color={theme.movGrey}
              text="Movimentação"
              paddingBottom={10}
            />
            <Text color={theme.movGrey90} text="Inativo" paddingBottom={20} />
          </WrapperFlex>
          <WrapperFlex column>
            <Text
              font="bold 16px/14px Calibri"
              color={theme.movGrey}
              text="Descrição"
              paddingBottom={10}
            />
            <Text
              color={theme.movGrey90}
              paddingBottom={20}
              text={lista?.dcDescricao || '-'}
            />
          </WrapperFlex>
        </WrapperFlex>
      </WrapperFlex>
    </Card>
  );
}

export default DadosLista;
